import queryStringUtilities from "query-string";
import { useLocation } from "react-router-dom";

const useQueryParams = () => queryStringUtilities.parse(useLocation().search);

export { useQueryParams };
